import React, { useEffect, useRef, lazy, createElement } from 'react';
const WA_URL = 'https://wa.me/34604836989?text=Hola,%20quiero%20un%20presupuesto%20gratis%20para%20instalar%20suelo%20nuevo';
function WaIcon() {
  return <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" data-id="element-0">
      <path d="M17.47 14.38c-.3-.15-1.74-.86-2-.95-.27-.1-.46-.15-.66.15-.2.3-.76.95-.93 1.14-.17.2-.34.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.66-1.6-.9-2.18-.24-.57-.48-.5-.66-.5h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.74-.71 1.99-1.4.24-.69.24-1.28.17-1.4-.07-.12-.27-.2-.57-.35zM12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2z" data-id="element-1" />
    </svg>;
}
const LOGO_DARK = 'https://cdn.magicpatterns.com/uploads/bMU6QbKGb4YJatm2LUPygb/parquet72h_logo_horizontal_transparente.png';
const LOGO_LIGHT = 'https://cdn.magicpatterns.com/uploads/47E9fPA4oFUNYrtrw4cnDk/ELITE_UTILS_(16).png';
function Logo({
  variant = 'dark'
}: {
  variant?: 'dark' | 'light';
}) {
  return <a href="#" className="logo" aria-label="parquet72h" data-id="element-2">
      <img src={variant === 'light' ? LOGO_LIGHT : LOGO_DARK} alt="parquet72h" className="logo-img" data-id="element-3" />
    </a>;
}
const VIDEOS = [{
  name: 'María G.',
  loc: 'Sarrià, Barcelona',
  poster: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=600&q=70'
}, {
  name: 'Jordi M.',
  loc: 'Gràcia, Barcelona',
  poster: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=600&q=70'
}, {
  name: 'Laura P.',
  loc: 'Sant Cugat',
  poster: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=600&q=70'
}, {
  name: 'Marc R.',
  loc: 'Eixample, Barcelona',
  poster: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=600&q=70'
}];
export function App() {
  const trackRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const SRC = 'https://elfsightcdn.com/platform.js';
    if (document.querySelector(`script[src="${SRC}"]`)) return;
    const s = document.createElement('script');
    s.src = SRC;
    s.async = true;
    document.head.appendChild(s);
  }, []);
  const scrollVid = (dir: number) => {
    const t = trackRef.current;
    if (!t) return;
    const card = t.querySelector<HTMLDivElement>('.vid-card');
    const step = card ? card.offsetWidth + 16 : 300;
    t.scrollBy({
      left: dir * step,
      behavior: 'smooth'
    });
  };
  const playVid = (e: React.MouseEvent<HTMLDivElement>) => {
    const card = e.currentTarget;
    const url = card.getAttribute('data-video');
    if (!url) {
      alert('Aquí irá el vídeo testimonial. Sustituye el atributo data-video de la tarjeta por la URL de tu vídeo (MP4 o enlace de tu CDN/Vimeo).');
      return;
    }
    if (card.querySelector('video')) return;
    const v = document.createElement('video');
    v.src = url;
    v.controls = true;
    v.autoplay = true;
    v.playsInline = true;
    card.appendChild(v);
  };
  return <>
      <header className="site-header" data-id="element-4">
        <div className="wrap nav" data-id="element-5">
          <Logo data-id="element-6" />
        </div>
      </header>

      {/* HERO */}
      <section className="hero" data-id="element-7">
        <div className="hero-bg" data-id="element-8">
          <img src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=70" alt="Suelo de parquet recién instalado en un salón moderno" data-id="element-9" />
        </div>
        <div className="wrap hero-inner" data-id="element-10">
          <span className="badge-72 anim d1" data-id="element-11">
            <span className="dot" data-id="element-12"></span> Barcelona y alrededores
          </span>
          <h1 className="anim d2" data-id="element-13">
            Tu suelo nuevo instalado en <span className="hl" data-id="element-14">72 horas</span>
          </h1>
          <p className="sub anim d3" data-id="element-15">
            Tarima, parquet o vinílico colocado por profesionales. Sin semanas
            de obra, sin polvo, sin caos. Rápido, limpio y con garantía por
            escrito.
          </p>
          <div className="anim d4" data-id="element-16">
            <a className="btn-wa big" href={WA_URL} data-id="element-17">
              <WaIcon data-id="element-18" /> Pide tu presupuesto GRATIS
            </a>
            <p className="reassure" data-id="element-19">
              <b data-id="element-20">✓ Gratis y sin compromiso</b> · Respuesta en minutos por
              WhatsApp
            </p>
          </div>
        </div>
      </section>

      {/* TRUST STRIP */}
      <div className="strip" data-id="element-21">
        <div className="wrap" data-id="element-22">
          <span data-id="element-23">
            <svg fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" data-id="element-24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-25" />
            </svg>{' '}
            Instalación en 72h
          </span>
          <span data-id="element-26">
            <svg fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" data-id="element-27">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-28" />
            </svg>{' '}
            Presupuesto gratis
          </span>
          <span data-id="element-29">
            <svg fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" data-id="element-30">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-31" />
            </svg>{' '}
            Garantía por escrito
          </span>
          <span data-id="element-32">
            <svg fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" data-id="element-33">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-34" />
            </svg>{' '}
            Instalación limpia
          </span>
        </div>
      </div>

      {/* PAIN / PROMISE */}
      <section className="pad" data-id="element-35">
        <div className="wrap" data-id="element-36">
          <div className="center" style={{
          maxWidth: 640
        }} data-id="element-37">
            <p className="eyebrow" data-id="element-38">Olvídate de las obras eternas</p>
            <h2 className="title" data-id="element-39">
              Cambiar el suelo no tiene por qué arruinarte el mes
            </h2>
            <p className="lead center" data-id="element-40">
              La mayoría imagina semanas de polvo, ruido y la casa patas arriba.
              Con parquet72h es otra historia.
            </p>
          </div>
          <div className="vs" data-id="element-41">
            <div className="vs-card bad" data-id="element-42">
              <h3 data-id="element-43">La reforma tradicional</h3>
              <ul className="vs-list" data-id="element-44">
                <li data-id="element-45">
                  <span className="ico" data-id="element-46">✕</span> Semanas con la casa inhabitable
                </li>
                <li data-id="element-47">
                  <span className="ico" data-id="element-48">✕</span> Polvo y escombros por todas
                  partes
                </li>
                <li data-id="element-49">
                  <span className="ico" data-id="element-50">✕</span> Fechas que se alargan sin fin
                </li>
                <li data-id="element-51">
                  <span className="ico" data-id="element-52">✕</span> Presupuestos que crecen sobre
                  la marcha
                </li>
              </ul>
            </div>
            <div className="vs-arrow" data-id="element-53">→</div>
            <div className="vs-card good" data-id="element-54">
              <h3 className="vs-card-title" data-id="element-55">
                <span data-id="element-56">Con</span>
                <Logo variant="light" data-id="element-57" />
              </h3>
              <ul className="vs-list" data-id="element-58">
                <li data-id="element-59">
                  <span className="ico" data-id="element-60">✓</span> Tu suelo nuevo listo en 72
                  horas
                </li>
                <li data-id="element-61">
                  <span className="ico" data-id="element-62">✓</span> Instalación limpia y ordenada
                </li>
                <li data-id="element-63">
                  <span className="ico" data-id="element-64">✓</span> Fecha cerrada que cumplimos
                </li>
                <li data-id="element-65">
                  <span className="ico" data-id="element-66">✓</span> Presupuesto claro y sin
                  sorpresas
                </li>
              </ul>
            </div>
          </div>
          <div className="center" style={{
          marginTop: 38
        }} data-id="element-67">
            <a className="btn-wa" href={WA_URL} data-id="element-68">
              <WaIcon data-id="element-69" /> Quiero mi suelo nuevo en 72h
            </a>
          </div>
        </div>
      </section>

      {/* QUE INSTALAMOS */}
      <section className="pad" style={{
      background: 'var(--cream-2)'
    }} data-id="element-70">
        <div className="wrap" data-id="element-71">
          <div className="center" style={{
          maxWidth: 620
        }} data-id="element-72">
            <p className="eyebrow" data-id="element-73">Todo tipo de suelo nuevo</p>
            <h2 className="title" data-id="element-74">Instalamos el suelo que quieres</h2>
            <p className="lead center" data-id="element-75">
              Sea cual sea tu estilo y tu presupuesto, tenemos la solución y la
              colocamos nosotros.
            </p>
          </div>
          <div className="grid3" data-id="element-76">
            <div className="floor-card" data-id="element-77">
              <img src="https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?auto=format&fit=crop&w=800&q=70" alt="Tarima flotante" data-id="element-78" />
              <div className="cap" data-id="element-79">
                <h3 data-id="element-80">Tarima flotante</h3>
                <p data-id="element-81">Rápida, cálida y económica. Lista en un día.</p>
              </div>
            </div>
            <div className="floor-card" data-id="element-82">
              <img src="https://images.unsplash.com/photo-1604709177225-055f99402ea3?auto=format&fit=crop&w=800&q=70" alt="Parquet de madera" data-id="element-83" />
              <div className="cap" data-id="element-84">
                <h3 data-id="element-85">Parquet de madera</h3>
                <p data-id="element-86">Madera natural de primera. Elegancia que dura.</p>
              </div>
            </div>
            <div className="floor-card" data-id="element-87">
              <img src="https://images.unsplash.com/photo-1615873968403-89e068629265?auto=format&fit=crop&w=800&q=70" alt="Suelo vinílico SPC" data-id="element-88" />
              <div className="cap" data-id="element-89">
                <h3 data-id="element-90">Vinílico / SPC</h3>
                <p data-id="element-91">Resistente al agua, perfecto para cocina y baño.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PASOS */}
      <section className="pad" data-id="element-92">
        <div className="wrap" data-id="element-93">
          <div className="center" style={{
          maxWidth: 600
        }} data-id="element-94">
            <p className="eyebrow" data-id="element-95">Así de fácil</p>
            <h2 className="title" data-id="element-96">Tu suelo nuevo en 3 pasos</h2>
          </div>
          <div className="steps" data-id="element-97">
            <div className="step" data-id="element-98">
              <span className="num" data-id="element-99"></span>
              <h3 data-id="element-100">Escríbenos por WhatsApp</h3>
              <p data-id="element-101">
                Cuéntanos qué necesitas y te damos presupuesto gratis, sin
                compromiso.
              </p>
            </div>
            <div className="step" data-id="element-102">
              <span className="num" data-id="element-103"></span>
              <h3 data-id="element-104">Visita y medición</h3>
              <p data-id="element-105">Vamos a tu casa, medimos y cerramos fecha y precio cerrado.</p>
            </div>
            <div className="step" data-id="element-106">
              <span className="num" data-id="element-107"></span>
              <h3 data-id="element-108">Instalamos en 72h</h3>
              <p data-id="element-109">
                Colocamos tu suelo nuevo de forma limpia y profesional. Listo
                para pisar.
              </p>
            </div>
          </div>
          <div className="center" style={{
          marginTop: 44
        }} data-id="element-110">
            <a className="btn-wa" href={WA_URL} data-id="element-111">
              <WaIcon data-id="element-112" /> Empezar ahora por WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* POR QUE */}
      <section className="pad why" data-id="element-113">
        <div className="wrap" data-id="element-114">
          <div className="center" style={{
          maxWidth: 620
        }} data-id="element-115">
            <p className="eyebrow" data-id="element-116">Por qué elegirnos</p>
            <h2 className="title" data-id="element-117">El suelo bien puesto, a la primera</h2>
          </div>
          <div className="feats" data-id="element-118">
            <div className="feat" data-id="element-119">
              <div className="fico" data-id="element-120">
                <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-121">
                  <circle cx="12" cy="12" r="9" data-id="element-122" />
                  <path strokeLinecap="round" d="M12 7v5l3 2" data-id="element-123" />
                </svg>
              </div>
              <div data-id="element-124">
                <h3 data-id="element-125">Instalación en 72 horas</h3>
                <p data-id="element-126">Cumplimos la fecha que te damos. Sin retrasos ni excusas.</p>
              </div>
            </div>
            <div className="feat" data-id="element-127">
              <div className="fico" data-id="element-128">
                <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-129">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14c-4 0-7 2-7 5v1h14v-1c0-3-3-5-7-5z" data-id="element-130" />
                </svg>
              </div>
              <div data-id="element-131">
                <h3 data-id="element-132">Equipo profesional</h3>
                <p data-id="element-133">
                  Instaladores con años de experiencia. Acabados impecables.
                </p>
              </div>
            </div>
            <div className="feat" data-id="element-134">
              <div className="fico" data-id="element-135">
                <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-136">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-137" />
                </svg>
              </div>
              <div data-id="element-138">
                <h3 data-id="element-139">Presupuesto gratis</h3>
                <p data-id="element-140">Sin compromiso y sin letra pequeña. Sabes lo que pagas.</p>
              </div>
            </div>
            <div className="feat" data-id="element-141">
              <div className="fico" data-id="element-142">
                <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-143">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-144" />
                </svg>
              </div>
              <div data-id="element-145">
                <h3 data-id="element-146">Instalación limpia</h3>
                <p data-id="element-147">Protegemos tu casa y recogemos todo al terminar.</p>
              </div>
            </div>
            <div className="feat" data-id="element-148">
              <div className="fico" data-id="element-149">
                <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-150">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.6-2.4A9 9 0 1112 3a9 9 0 019.6 6.6z" data-id="element-151" />
                </svg>
              </div>
              <div data-id="element-152">
                <h3 data-id="element-153">Garantía por escrito</h3>
                <p data-id="element-154">Te entregamos garantía firmada de la instalación.</p>
              </div>
            </div>
            <div className="feat" data-id="element-155">
              <div className="fico" data-id="element-156">
                <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-157">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 21s-7-5-7-11a7 7 0 0114 0c0 6-7 11-7 11z" data-id="element-158" />
                  <circle cx="12" cy="10" r="2.5" data-id="element-159" />
                </svg>
              </div>
              <div data-id="element-160">
                <h3 data-id="element-161">Barcelona y alrededores</h3>
                <p data-id="element-162">Damos servicio en toda la provincia. Cerca de ti.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* GALERIA */}
      <section className="pad" data-id="element-163">
        <div className="wrap" data-id="element-164">
          <div className="center" style={{
          maxWidth: 600
        }} data-id="element-165">
            <p className="eyebrow" data-id="element-166">Trabajos reales</p>
            <h2 className="title" data-id="element-167">Antes y después</h2>
            <p className="lead center" data-id="element-168">
              El cambio que un buen suelo puede dar a tu casa.
            </p>
          </div>
          <div className="gallery" data-id="element-169">
            <div className="ph" data-id="element-170">
              <span className="tag" data-id="element-171">Antes</span>
              <img src="https://images.unsplash.com/photo-1581622558663-b2e33377dfb2?auto=format&fit=crop&w=600&q=70" alt="Habitación antes" data-id="element-172" />
            </div>
            <div className="ph" data-id="element-173">
              <span className="tag" data-id="element-174">Después</span>
              <img src="https://images.unsplash.com/photo-1600210492493-0946911123ea?auto=format&fit=crop&w=600&q=70" alt="Habitación después" data-id="element-175" />
            </div>
            <div className="ph" data-id="element-176">
              <span className="tag" data-id="element-177">Antes</span>
              <img src="https://images.unsplash.com/photo-1567767292278-a4f21aa2d36e?auto=format&fit=crop&w=600&q=70" alt="Salón antes" data-id="element-178" />
            </div>
            <div className="ph" data-id="element-179">
              <span className="tag" data-id="element-180">Después</span>
              <img src="https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=600&q=70" alt="Salón después" data-id="element-181" />
            </div>
          </div>
        </div>
      </section>

      {/* VIDEOS CARRUSEL */}
      <section className="pad videos" data-id="element-182">
        <div className="wrap" data-id="element-183">
          <div className="center" style={{
          maxWidth: 620
        }} data-id="element-184">
            <p className="eyebrow" data-id="element-185">Clientes reales</p>
            <h2 className="title" data-id="element-186">Lo que dicen nuestros clientes</h2>
            <p className="lead center" data-id="element-187">
              Vecinos de Barcelona que ya pisan su suelo nuevo en 72 horas.
            </p>
          </div>
          <div className="vid-track" ref={trackRef} data-id="element-188">
            {VIDEOS.map((v, i) => <div key={i} className="vid-card" onClick={playVid} data-video="" data-id="element-189">
                <img className="poster" src={v.poster} alt={`Testimonio ${v.name}`} data-id="element-190" />
                <div className="ov" data-id="element-191">
                  <div className="meta" data-id="element-192">
                    <div className="stars" data-id="element-193">★★★★★</div>
                    <div className="name" data-id="element-194">{v.name}</div>
                    <div className="loc" data-id="element-195">{v.loc}</div>
                  </div>
                </div>
                <div className="play" data-id="element-196">
                  <svg fill="currentColor" viewBox="0 0 24 24" data-id="element-197">
                    <path d="M8 5v14l11-7z" data-id="element-198" />
                  </svg>
                </div>
              </div>)}
          </div>
          <div className="vid-nav" data-id="element-199">
            <button onClick={() => scrollVid(-1)} aria-label="Anterior" data-id="element-200">
              ‹
            </button>
            <button onClick={() => scrollVid(1)} aria-label="Siguiente" data-id="element-201">
              ›
            </button>
          </div>
          <p className="vid-hint" data-id="element-202">Desliza para ver más testimonios →</p>
          <div className="center" style={{
          marginTop: 30
        }} data-id="element-203">
            <a className="btn-wa" href={WA_URL} data-id="element-204">
              <WaIcon data-id="element-205" /> Quiero ser el próximo
            </a>
          </div>
        </div>
      </section>

      {/* TESTIMONIOS TEXTO */}
      <section className="pad" style={{
      background: 'var(--cream-2)'
    }} data-id="element-206">
        <div className="wrap" data-id="element-207">
          <div className="center" style={{
          maxWidth: 600
        }} data-id="element-208">
            <p className="eyebrow" data-id="element-209">Opiniones</p>
            <h2 className="title" data-id="element-210">Más de 200 hogares con suelo nuevo</h2>
          </div>
          <div className="elfsight-app-9fcb0efc-ebd1-4b2e-8331-535f6d6f5e68" data-elfsight-app-lazy style={{
          marginTop: 42
        }} data-id="element-211"></div>
        </div>
      </section>

      {/* OFERTA FINAL */}
      <section className="pad final" data-id="element-212">
        <div className="wrap" data-id="element-213">
          <span className="offer-tag" data-id="element-214">Presupuesto gratis sin compromiso</span>
          <h2 data-id="element-215">¿Listo para tu suelo nuevo en 72 horas?</h2>
          <p data-id="element-216">
            Escríbenos ahora por WhatsApp. Te respondemos en minutos y te damos
            precio sin compromiso.
          </p>
          <a className="btn-wa big" href={WA_URL} data-id="element-217">
            <WaIcon data-id="element-218" /> Pide tu presupuesto GRATIS
          </a>
          <p className="micro" data-id="element-219">Barcelona y alrededores · Respuesta inmediata</p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="site-footer" data-id="element-220">
        <div className="wrap" data-id="element-221">
          <div className="foot-top" data-id="element-222">
            <div className="fcol" data-id="element-223">
              <Logo variant="light" data-id="element-224" />
              <p style={{
              maxWidth: 280,
              marginTop: 12
            }} data-id="element-225">
                Instalación de suelos nuevos en 72 horas. Rápido, limpio y con
                garantía.
              </p>
            </div>
            <div className="fcol" data-id="element-226">
              <h4 data-id="element-227">Servicios</h4>
              <p data-id="element-228">Tarima flotante</p>
              <p data-id="element-229">Parquet de madera</p>
              <p data-id="element-230">Suelo vinílico / SPC</p>
            </div>
            <div className="fcol" data-id="element-231">
              <h4 data-id="element-232">Contacto</h4>
              <p data-id="element-233">
                <a href={WA_URL} data-id="element-234">WhatsApp: +34 604 836 989</a>
              </p>
              <p data-id="element-235">Barcelona y alrededores</p>
              <p data-id="element-236">
                <a href="https://www.parquet72h.com" data-id="element-237">www.parquet72h.com</a>
              </p>
            </div>
          </div>
          <div className="foot-bot" data-id="element-238">
            © 2026 parquet72h.com · Todos los derechos reservados
          </div>
        </div>
      </footer>

      {/* STICKY MOBILE BAR */}
      <div className="sticky-bar" data-id="element-239">
        <a className="btn-wa" href={WA_URL} data-id="element-240">
          <WaIcon data-id="element-241" /> Presupuesto GRATIS por WhatsApp
        </a>
      </div>

      {/* FLOATING DESKTOP WA */}
      <a className="float-wa" href={WA_URL} aria-label="WhatsApp" data-id="element-242">
        <WaIcon data-id="element-243" />
      </a>
    </>;
}